module.exports = {"542226100":"曲松镇","542226101":"罗布沙镇","542226200":"邱多江乡","542226201":"堆随乡","542226202":"下江乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542226.json
// module id = 2751
// module chunks = 0